import '../styles/whatToKnow.scss';
import WtkInfoPanel from './WtkInfoPanel';
import WtkInfoPanelCarousel from './WtkInfoPanelCarousel';
import WtkInfoPanelLeft from './WtkInfoPanelLeft';
import Lottie from 'react-lottie';

import wtkIcon1 from '../assets/wtkIcon1.svg';
import wtkIcon2 from '../assets/wtkIcon2.svg';
import wtkIcon3 from '../assets/wtkIcon3.svg';
import wtkIcon4 from '../assets/wtkIcon4.svg';
import wtkIcon5 from '../assets/wtkIcon5.svg';
import wtkIcon6 from '../assets/wtkIcon6.svg';
import wtkPq1 from '../assets/wtkPq1.jpg';
import wtkPq2 from '../assets/wtkPq2.jpg';
import wtkPq3 from '../assets/wtkPq3.jpg';
import lottie3 from '../assets/lotties/enfamil_3.json';
import lottie4 from '../assets/lotties/enfamil_4.json';
import lottie5 from '../assets/lotties/enfamil_5.json';
import lottie6 from '../assets/lotties/enfamil_6.json';

const WhatToKnow = () => {
  const lottie3Options = {
    loop: true,
    autoplay: true,
    animationData: lottie3,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const lottie4Options = {
    loop: true,
    autoplay: true,
    animationData: lottie4,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const lottie5Options = {
    loop: true,
    autoplay: true,
    animationData: lottie5,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const lottie6Options = {
    loop: true,
    autoplay: true,
    animationData: lottie6,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div className="wtk">
      <div className="wtk__header">
        <div className="graphic3">
          <Lottie options={lottie3Options} className="graphic3" />
        </div>
        <h2>Here's What to Know</h2>
      </div>
      <WtkInfoPanel
        icon={wtkIcon1}
        pg1="All our infant formulas undergo extensive quality tests and checks, which meet all regulatory standards including the ones set by the US FDA."
        // pg2="We assure you our trusted products are crafted with high safety standards in place. This includes Enfamil, Nutramigen, and PurAmino branded products."
        pq={wtkPq1}
      />
      {/* <div className="wtk__paragraph">
        <p>
          All our infant formulas undergo extensive quality tests and checks, which meet all
          regulatory standards including the ones set by the US FDA
        </p>
        <div className="graphic4">
          <Lottie options={lottie4Options} />
        </div>
      </div> */}
      <WtkInfoPanelLeft
        icon={wtkIcon2}
        pg1="WE’VE RAMPED UP OUR PRODUCTION TO HELP SERVE FAMILIES WHO HAVE BEEN UNABLE TO CONTINUE WITH THEIR PREVIOUS BRAND DUE TO THE SHORTAGE."
        pg2="Our team is working around the clock and producing our high-quality formulas at record-high levels."
        pq={wtkPq2}
      />
      <div className="wtk__stats">
        <div className="graphic5">
          <Lottie options={lottie5Options} />
          {/* <img src={graphic5} alt="graphic of colorful shpaes" /> */}
        </div>
        <div className="wtk__stats__indStat">
          <img src={wtkIcon3} alt="gears graphic" />
          <p>24/7</p>
          <p>Operating 24/7 at US manufacturing facilities</p>
        </div>
        <div className="wtk__stats__indStat">
          <img src={wtkIcon4} alt="gears graphic" />
          <p>66 million servings</p>
          <p>Secured FDA approval for largest import of infant formula</p>
        </div>
        <div className="wtk__stats__indStat">
          <img src={wtkIcon5} alt="gears graphic" />
          <p>40%</p>
          <p>Feeding more than 40% of all WIC infants</p>
        </div>
        <div className="graphic6">
          <Lottie options={lottie6Options} />
          {/* <img src={graphic6} alt="colorful graphic of shapes" /> */}
        </div>
      </div>
      <WtkInfoPanelCarousel
        icon={wtkIcon6}
        pg1="WE ARE DELIVERING FREE SAMPLES TO PEDIATRICIANS AND HOSPITALS."
        pg2="In this critical time, we're helping babies in urgent need have access to formula when seeking pediatric care."
        pq={wtkPq3}
      />
      <div className="wtk__paragraph">
        <p>
          For over 100 years, the maker of Enfamil® has been providing safe and effective formula
          for babies
        </p>
      </div>
    </div>
  );
};

export default WhatToKnow;
